import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";

let _cache = null;

// Fetches editable site content once and caches it.
export function useContent() {
  const [content, setContent] = useState(_cache || {});
  useEffect(() => {
    if (_cache) { setContent(_cache); return; }
    api.get("/content").then((r) => { _cache = r.data; setContent(r.data); }).catch(() => {});
  }, []);
  return content;
}
